import { ProductDetailsSellerSettings } from '@components/product/ProductDetailsSellerSettings';

import {
  useProductDetailsSellerSettingsQuery,
} from './gql/graphql.v3.generated';

interface Props {
  className?: string,
  productId: number,
}

export const ProductDetailsSellerSettingsContainer: React.FC<Props> = ({
  className,
  productId,
}) => {
  const { data } = useProductDetailsSellerSettingsQuery({
    variables: {
      productId,
    },
  })

  return (
    <ProductDetailsSellerSettings
      className={className}
      product={data?.productDetails}
    />
  );
};
